export default function WizardTemplate(data) {
    //language=HTML
    return `
        <style>
            form {
                display: inline-block;
                width: 100%;
            }

            #wizard-window {
                margin: auto;
                width: 80%;
                height: 700px;
                text-align: center;
                overflow-y: auto;
            }

            .question-div {
                font-size: 20px;
                padding: 20px;
            }

            #wizard-controllers {
                position: fixed;
                top: 0;
                padding-bottom: 20px;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: center;
            }

            body {
                background-image: none;
            }

        </style>
        <div id="wizardExample">
            <div style="margin: 30px;" id="stepper"></div>
            <div style="margin-top: 30px" id="wizard-window" class="demo-section k-content wide"></div>
        </div>`;
}